/** AIAssistantInfra AI Assistants name. */
export enum AIAssistantName {
  AURA = 'aura',
  ASK_AURA = 'askaura',
}
